import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Text, XStack } from 'tamagui';

import { BacklightPatternIcon } from './BacklightPatternIcon';
import { BacklightPattern } from '../../../hooks/firmware/useBacklight';

interface PatternSelectorProps {
  value: BacklightPattern;
  onChange: (pattern: BacklightPattern) => void;
  isDisabled?: boolean;
}

export const PatternSelector: React.FC<PatternSelectorProps> = ({
  value,
  onChange,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  
  const patternOptions: BacklightPattern[] = ['Solid', 'Off', 'Slow Pulse'];

  return (
    <Select
      value={value}
      onValueChange={(val) => onChange(val as BacklightPattern)}
      aria-disabled={isDisabled}
    >
      <Select.Trigger width="auto" iconAfter={null}>
        <XStack alignItems="center" gap="$2">
          <BacklightPatternIcon pattern={value} size={20} />
          <Select.Value>
            <Text color="$white12" fontSize="$7">
              {t(`settings.backlight.patterns.${value.toLowerCase().replace(' ', '_')}`)}
            </Text>
          </Select.Value>
        </XStack>
      </Select.Trigger>

      <Select.Content>
        <Select.ScrollUpButton />
        <Select.Viewport>
          {patternOptions.map((pattern, index) => (
            <Select.Item key={pattern} value={pattern} index={index}>
              <XStack alignItems="center" gap="$2">
                <BacklightPatternIcon pattern={pattern} size={20} />
                <Select.ItemText>
                  {t(`settings.backlight.patterns.${pattern.toLowerCase().replace(' ', '_')}`)}
                </Select.ItemText>
              </XStack>
            </Select.Item>
          ))}
        </Select.Viewport>
        <Select.ScrollDownButton />
      </Select.Content>
    </Select>
  );
};
